import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


    export const getWarehouseIoNo = (docsClassificationId,warehouseId,warehouseIOType,id=null,) =>
      http({
        baseURL: INVENTORYANDSALES_URL,
        url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.InventoryReceipt.nextNo,
        method: "get",
        headers: { "Accept-Language": "en" },
        params:{
          docsClassificationId,
          id,
          warehouseId,
          warehouseIOType
        }
      })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
                     export const getSources = (
          pageNumber = 1,
          pageSize = 10,
          searchString = null,
          warehouseId
        ) =>
          http({
            baseURL: INVENTORYANDSALES_URL,
            url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.InventoryReceipt.browse,
            method: "get",
            params: {
              PageNumber: pageNumber,
              PageSize: pageSize,
              SearchString: searchString,
              warehouseId
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        export const GenerateFromSource = (SourceId) =>
          http({
            baseURL: INVENTORYANDSALES_URL,
            url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.ReturnRemittance.generate,
            method: "get",
            params: {

              SourceId,
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((err) => {
              return Promise.reject(err);
            });
 